import { SearchService } from './SearchService';

export class FacetFilters<TFacets extends string, ISearchResult> {
	protected _facetName;
	protected _facets;
	protected _searchService;
	protected _element: JQuery<HTMLElement>;

	protected _topResultsCount: number | null = null;

	public constructor(
		element: JQuery<HTMLElement>,
		searchService: SearchService<TFacets, ISearchResult>,
		facetName: TFacets,
		facets: Map<string, string>,
	) {
		this._element = element;
		this._facetName = facetName;
		this._facets = facets;
		this._searchService = searchService;

		this.render();

		searchService.addResultsListener(() => this.render());
	}

	protected render() {
		if (this._facets) {
			let hasActiveFacet = false;
			let nbHits = 0;
			// Create the facets
			const facetElements: JQuery<HTMLElement>[] = [];
			this._facets.forEach((facetLabel, singleFacet) => {
				let activeClass = '';
				let count = 0;
				if (this.isActiveFilter(singleFacet)) {
					activeClass = 'active';
					hasActiveFacet = true;
				}
				const facetCount = this._searchService.facetCounts;
				if (
					facetCount &&
					this._facetName in facetCount &&
					singleFacet in facetCount[this._facetName]
				) {
					count = facetCount[this._facetName][singleFacet];
				}

				let disabled = count === 0 ? 'disabled' : '';

				const facetElement = $(`
					<button ${disabled} class="${activeClass} opacity-100 disabled:opacity-30">
						<span class="font-sans">
							${facetLabel} <span class="facet-count">(${count})</span>
						</span>
					</button>
				`).on('click', () => {
					this.setSearchFacet([singleFacet]);
				});

				facetElements.push(facetElement);
			});

			let activeClass = '';
			if (!hasActiveFacet) {
				activeClass = 'active';
			}

			if (this._searchService.algoliaResults) {
				nbHits = this._searchService.algoliaResults.nbHits;
			}

			// Add the top results at the beginning
			facetElements.unshift(
				$(`
					<button  class="${activeClass} opacity-100 disabled:opacity-30">
					<span class="font-sans">
							Top Results
						</span>
					</button>
				`).on('click', () => {
					this.setSearchFacet(undefined);
				}),
			);
			this._element.empty().append(facetElements);
		}
	}

	protected isActiveFilter(filterValue: string) {
		if (
			this._searchService.searchParams.facetsData &&
			this._facetName in this._searchService.searchParams.facetsData &&
			this._searchService.searchParams.facetsData[
				this._facetName
			].indexOf(filterValue) >= 0
		) {
			return true;
		}

		return false;
	}

	protected setSearchFacet(facetValue: string[] | undefined) {
		const newSearchParams = this._searchService.searchParams;
		if (!newSearchParams.facetsData) {
			newSearchParams.facetsData = {} as any;
		}

		if (facetValue) {
			newSearchParams.facetsData[this._facetName] = facetValue;
		} else {
			delete newSearchParams.facetsData[this._facetName];
		}

		this._searchService.searchParams = newSearchParams;
	}
}



// WEBPACK FOOTER //
// ./scripts/algolia/FacetFilters.ts